module.exports = __webpack_public_path__ + "dd63d1acebd19901c25d0f3112c4528d.png";